import React, { useState } from 'react';
import { X, User } from 'lucide-react';

interface InsertFirstNameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onInsert: (fallback: string) => void;
}

export function InsertFirstNameModal({ isOpen, onClose, onInsert }: InsertFirstNameModalProps) {
  const [fallback, setFallback] = useState('lezer');

  if (!isOpen) return null;

  const handleInsert = () => {
    onInsert(fallback);
    onClose();
    setFallback('lezer');
  };

  const handleClose = () => {
    onClose();
    setFallback('lezer');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-[#231F20] flex items-center gap-2">
            <User className="w-5 h-5" />
            Voornaam Invoegen
          </h3>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          Voeg een gepersonaliseerde voornaam toe. Als een contact geen voornaam heeft, wordt de fallback tekst gebruikt.
        </p>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Fallback Tekst
          </label>
          <input
            type="text"
            value={fallback}
            onChange={(e) => setFallback(e.target.value)}
            placeholder="lezer"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent outline-none"
          />
          <p className="text-xs text-gray-500 mt-1">
            Deze tekst wordt gebruikt als een contact geen voornaam heeft
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-900 font-medium mb-1">
            Preview:
          </p>
          <p className="text-sm text-blue-800">
            "Hoi <code className="bg-blue-100 px-1 py-0.5 rounded font-medium">first_name</code>" wordt "Hoi Jan"
          </p>
          <p className="text-sm text-blue-800">
            Als geen voornaam: "Hoi <code className="bg-blue-100 px-1 py-0.5 rounded font-medium">{fallback || 'lezer'}</code>"
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleClose}
            className="flex-1 btn-secondary"
          >
            Annuleren
          </button>
          <button
            onClick={handleInsert}
            className="flex-1 btn-primary flex items-center justify-center gap-2"
          >
            <User className="w-4 h-4" />
            Invoegen
          </button>
        </div>
      </div>
    </div>
  );
}
